export default __webpack_public_path__ + "static/media/avatar-default.400283ba.svg";